// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__3m7jI","tab":"ProcedureTabs_tab__2ZJu6"};